module.exports = __webpack_public_path__ + "img/logo.cf77c84b.png";